const login = function () {
  window.TLBS.component.login.show();
};
const logout = function () {
  window.TLBS.component.login.exit();
};

export { login, logout };
